var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vy-icon",style:({ transform: `scale(${_vm.scale})` })},[_c('img',{style:(_vm.style),attrs:{"src":"https://iv.okvu.cn/vugw/img/vuht.png","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }